// js/utils.js (VERSÃO CORRIGIDA E COMPLETA COM DOMPURIFY)

import DOMPurify from 'dompurify';

/**
 * Sanitiza uma string HTML usando DOMPurify para evitar injeção de scripts (XSS).
 * @param {string | null | undefined} html - O código HTML bruto.
 * @returns {string} O HTML sanitizado e seguro.
 */
export function sanitizeHTML(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html);
}

/**
 * Sanitiza uma string para exibição segura em HTML, escapando caracteres especiais.
 * Ideal para conteúdo de linha única como títulos e nomes de usuário.
 * @param {string | null | undefined} str - A string de entrada.
 * @returns {string} A string segura para ser usada em HTML.
 */
export function sanitizeText(str) {
  if (!str) return '';
  const tempDiv = document.createElement('div');
  tempDiv.textContent = str; // textContent automaticamente escapa <, >, &, etc.
  return tempDiv.innerHTML;
}

/**
 * Sanitiza e formata uma string para exibição em HTML, convertendo quebras de linha em <br>.
 * Ideal para o corpo de posts e mensagens que podem ter múltiplos parágrafos.
 * @param {string | null | undefined} str - A string de entrada.
 * @returns {string} A string formatada e segura para ser usada com innerHTML.
 */
export function sanitizeAndFormatText(str) {
  if (!str) return '';
  // Reutiliza a função principal de sanitização
  const sanitized = sanitizeText(str);
  // Agora que está seguro, podemos substituir as quebras de linha por <br>
  return sanitized.replace(/\n/g, '<br>');
}